import { useWoAttachmentsAuthorizationEnabled } from '../../feature-flags/useWoAttachmentsAuthorizationEnabled';
import { useActor } from '../authorization/useActor';
import {
  getAttachmentAccess,
  type AttachmentAccess,
} from './getAttachmentAccess';
import { toResource, type ServiceRequestRecord } from './toResource';

export const useServiceRequestAttachmentAccess = (
  record: ServiceRequestRecord
): AttachmentAccess =>
  getAttachmentAccess({
    actor: useActor(),
    resource: toResource(record),
    isEnforced: useWoAttachmentsAuthorizationEnabled(),
  });
